import React, { Fragment, useState } from "react";
import { Modal, Box, Typography, Grid, IconButton, Button, Divider } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ShareIcon from "@material-ui/icons/Share";
import Close from "@material-ui/icons/Close";
import ShareAccountModal from "./AccountModalComponents/ShareAccountModal";
import SMTPModal from "./AccountModalComponents/SMTPModal";
import styled from "styled-components";
import GoogleButton from 'react-google-button';

const ManageAccountsModal = ({
  from_emails,
  reconnectAccount,
  disconnectAccount,
  deleteAccount,
  addAccount,
  store,
  showAlert,
  mailData,
  setMailData,
}) => {
  const [accountModalData, setAccountModalData] = useState({
    isSMTPModal: false,
    accountHolder: "",
    showShareModal: false,
  });

  const openSMTPModal = () => {
    setAccountModalData({ ...accountModalData, isSMTPModal: true });
    setMailData({ ...mailData, openManageAccountModal: false });
  };

  return (
    <Fragment>
      {accountModalData.isSMTPModal && (
        <SMTPModal
          accountModalData={accountModalData}
          setAccountModalData={setAccountModalData}
          showAlert={showAlert}
          store={store}
        />
      )}
      {accountModalData.showShareModal && (
        <ShareAccountModal
          accountModalData={accountModalData}
          setAccountModalData={setAccountModalData}
          store={store}
          closeModal={() => {
            setMailData({ ...mailData, openManageAccountModal: false });
          }}
          showAlert={showAlert}
        />
      )}
      <Modal
        open={mailData.openManageAccountModal}
        onClose={() => setMailData({ ...mailData, openManageAccountModal: false })}
      >
        <StyledBox>
          <StyledGrid container alignItems="center">
            <Grid item>
              <Typography variant="h4">Manage Accounts</Typography>
            </Grid>
            <Grid item style={{ flex: "1" }}></Grid>
            <Grid item>
              <Close
                onClick={() => setMailData({ ...mailData, openManageAccountModal: false })}
                style={{ color: "white" }}
              />
            </Grid>
          </StyledGrid>
          <Grid container direction="column" style={{ padding: "10px" }}>
            <Grid container justify="center">
              <StyledGrid1 item>
                {/* <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    addAccount();
                    setMailData({ ...mailData, openManageAccountModal: false });
                  }}
                >
                  Connect new Gmail/Google Apps for work
                </Button> */}
                  <GoogleButton
                    type="dark"
                    onClick={() => { 
                      addAccount();
                      setMailData({ ...mailData, openManageAccountModal: false });
                     }}
                  />
              </StyledGrid1>
              <StyledGrid1 item>
                <StyledSMTPButton variant="outlined" color="primary" onClick={openSMTPModal}>
                  Connect new SMTP Account
                </StyledSMTPButton>
              </StyledGrid1>
            </Grid>
            <Divider />
            {from_emails.map((el) => (
              <Fragment key={el.id}>
                <Grid container alignItems="center" justify="center">
                  <Grid item>
                    <Button
                      variant="outlined"
                      color={el.status === "ACTIVE" ? "secondary" : "primary"}
                      onClick={
                        el.status === "ACTIVE"
                          ? () => disconnectAccount(el.id)
                          : () => reconnectAccount(el.id)
                      }
                    >
                      {el.status === "ACTIVE" ? "Disconnect" : "Reconnect"}
                    </Button>
                  </Grid>
                  <IconButton onClick={() => deleteAccount(el.id)}>
                    <DeleteIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setAccountModalData({
                        ...accountModalData,
                        showShareModal: true,
                        accountHolder: el,
                      });
                      setMailData({ ...mailData, openManageAccountModal: false });
                    }}
                  >
                    <ShareIcon />
                  </IconButton>
                  <Grid item>
                    <Typography>{el.email}</Typography>
                  </Grid>
                </Grid>
                <Divider />
              </Fragment>
            ))}
          </Grid>
        </StyledBox>
      </Modal>
    </Fragment>
  );
};

export default ManageAccountsModal;

const StyledBox = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border-radius: 5px;
    overflow: hidden;
    boxshadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
  }
`;

const StyledGrid = styled(Grid)`
  && {
    padding: 10px 10px 10px 10px;
    background-color: #404040;
    color: white;
  }
`;

const StyledGrid1 = styled(Grid)`
  && {
    margin-right: 10px;
    margin-bottom: 5px;
  }
`;

const StyledSMTPButton = styled(Button)`
&& {
  padding: 14px;
}
`